import { url, header } from "../../apis/Index";
import axios from "axios";

export const getBeneficiaryInfo = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_INFO",
      fetchingInfo: true,
    });
    axios
      .get(`${url}/beneficiaries/${id}`, {
        headers: header,
      })
      .then((beneficiary) => {
        dispatch({
          type: "GET_BENEFICIARY_INFO",
          beneficiary,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_INFO",
          fetchingInfo: true,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_INFO_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};

export const getBeneficiaryParents = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_PARENT_INFO",
      fetchingInfo: true,
    });
    axios
      .get(`${url}/parents_caregiver/${id}`, {
        headers: header,
      })
      .then((parent) => {
        dispatch({
          type: "GET_BENEFICIARY_PARENTS",
          parent,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_PARENT_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_PARENT_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_PARENT_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};

export const getBeneficiaryCurrentCaregivers = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_CAREGIVER_INFO",
      fetchingInfo: true,
    });
    axios
      .get(`${url}/caregivers/current_caregiver/${id}`, {
        headers: header,
      })
      .then((currentCaregivers) => {
        dispatch({
          type: "GET_BENEFICIARY_CURRENT_CAREGIVERS",
          currentCaregivers,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_CAREGIVER_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_CAREGIVER_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_CAREGIVER_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};

export const getBeneficiaryCurrentInsurance = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_INSURANCE_INFO",
      fetchingInfo: true,
    });
    axios
      .get(`${url}/beneficiaries-insurances/current-insurance/${id}`, {
        headers: header,
      })
      .then((currentInsurance) => {
        dispatch({
          type: "GET_BENEFICIARY_CURRENT_INSURANCE",
          currentInsurance,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_INSURANCE_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_INSURANCE_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_INSURANCE_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};

export const getBeneficiaryCurrentCategory = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_CATEGORY_INFO",
      fetchingInfo: true,
    });
    axios
      .get(`${url}/v1/beneficiaries_categories/current-category/${id}`, {
        headers: header,
      })
      .then((currentCategory) => {
        dispatch({
          type: "GET_BENEFICIARY_CURRENT_UBUDEHE_CATEGORY",
          currentCategory,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_CATEGORY_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_CATEGORY_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_CATEGORY_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};

export const getBeneficiaryCurrentResidence = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_RESIDENCE_INFO",
      fetchingInfo: true,
    });
    axios
      .get(`${url}/residences/current_residence/${id}`, {
        headers: header,
      })
      .then((currentResidence) => {
        dispatch({
          type: "GET_BENEFICIARY_CURRENT_RESIDENCE",
          currentResidence,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_RESIDENCE_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_RESIDENCE_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_RESIDENCE_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};
export const getBeneficiaryCurrentSchool = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_SCHOOL_INFO",
      fetchingInfo: true,
    });
    axios
      .get(`${url}/beneficiaries-schools/current-school/${id}`, {
        headers: header,
      })
      .then((currentSchool) => {
        dispatch({
          type: "GET_BENEFICIARY_CURRENT_SCHOOL",
          currentSchool,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_SCHOOL_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_SCHOOL_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_SCHOOL_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};

export const getBeneficiaryLastRecordedMarks = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_MARKS_INFO",
      fetchingInfo: true,
    });
    axios
      .get(`${url}/beneficiary-performances/current-performance/${id}`, {
        headers: header,
      })
      .then((currentScore) => {
        dispatch({
          type: "GET_BENEFICIARY_LAST_MARKS",
          currentScore,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_MARKS_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_MARKS_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_MARKS_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};

export const getBeneficiaryLastSaturdayStudy = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_SAT_STUDY_INFO",
      fetchingInfo: true,
    });
    axios
      .get(
        `${url}/v1/saturday-event-attendees/last-attended/beneficiary/${id}`,
        {
          headers: header,
        }
      )
      .then((attendeeInfo) => {
        dispatch({
          type: "GET_BENEFICIARY_LAST_SAT_STUDY",
          attendeeInfo,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_SAT_STUDY_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_SAT_STUDY_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_SAT_STUDY_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};

export const getBeneficiaryLastMeeting = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_MEETING_INFO",
      fetchingInfo: true,
    });
    axios
      .get(
        `${url}/v1/meeting_event_attendees/last-attended/beneficiary/${id}`,
        {
          headers: header,
        }
      )
      .then((attendeeInfo) => {
        dispatch({
          type: "GET_BENEFICIARY_LAST_MEETING",
          attendeeInfo,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_MEETING_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_MEETING_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_MEETING_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};
export const getBeneficiaryLastVisit = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_VISIT_INFO",
      fetchingInfo: true,
    });
    axios
      .get(`${url}/v1/visited_beneficiaries/last-visit/beneficiary/${id}`, {
        headers: header,
      })
      .then((attendeeInfo) => {
        dispatch({
          type: "GET_BENEFICIARY_LAST_VISIT",
          attendeeInfo,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_VISIT_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_VISIT_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_VISIT_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};
export const getBeneficiaryLastAssocciation = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_ASSOCCIATION_INFO",
      fetchingInfo: true,
    });
    axios
      .get(`${url}/assocciations/current-assocciation/${id}`, {
        headers: header,
      })
      .then((memberInfo) => {
        dispatch({
          type: "GET_BENEFICIARY_LAST_ASSOCCIATION",
          memberInfo,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_ASSOCCIATION_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_ASSOCCIATION_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_ASSOCCIATION_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};
export const getBeneficiaryLastFund = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_FUND_INFO",
      fetchingInfo: true,
    });
    axios
      .get(`${url}/v1/funded-beneficiaries/current-fund/${id}`, {
        headers: header,
      })
      .then((fundInfo) => {
        dispatch({
          type: "GET_BENEFICIARY_LAST_FUND",
          fundInfo,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_FUND_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_FUND_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_FUND_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};
// export const getBeneficiaryLastHealthTest = (id) => {
//   return (dispatch) => {
//     axios
//       .get(`${url}/v1/health_test_event_attendees/last/${id}`, {
//         headers: header,
//       })
//       .then((attendeeInfo) => {
//         dispatch({
//           type: "GET_BENEFICIARY_LAST_HEALTH_TEST",
//           attendeeInfo,
//         });
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };
// };

// export const getBeneficiaryAllTest = (id) => {
//   return (dispatch) => {
//     axios
//       .get(`${url}/v1/health_test_event_attendees/${id}`, {
//         headers: header,
//       })
//       .then((healthTests) => {
//         dispatch({
//           type: "GET_BENEFICIARY_ALL_ATTENDED_HEALTH_TEST",
//           healthTests,
//         });
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };
// };

export const getBeneficiaryAllMeeting = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_TOTAL_MEETING_INFO",
      fetchingInfo: true,
    });
    axios
      .get(`${url}/v1/meeting-event-attendees/${id}`, {
        headers: header,
      })
      .then((meetings) => {
        dispatch({
          type: "GET_BENEFICIARY_ALL_ATTENDED_MEETING",
          meetings,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_MEETING_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_MEETING_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_MEETING_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};

export const getBeneficiaryAllSatStudies = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_TOTAL_SAT_STUDY_INFO",
      fetchingInfo: true,
    });
    axios
      .get(`${url}/v1/sat_studies_event_attendees/${id}`, {
        headers: header,
      })
      .then((satStudies) => {
        dispatch({
          type: "GET_BENEFICIARY_ALL_ATTENDED_SAT_STUDIES",
          satStudies,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_SAT_STUDY_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_SAT_STUDY_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_SAT_STUDY_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};

export const getBeneficiaryAllVisit = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_TOTAL_VISIT_INFO",
      fetchingInfo: true,
    });
    axios
      .get(`${url}/v1/visit_event_attendees/${id}`, {
        headers: header,
      })
      .then((visits) => {
        dispatch({
          type: "GET_BENEFICIARY_ALL_ATTENDED_VISIT",
          visits,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_VISIT_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_VISIT_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_VISIT_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};
export const getBeneficiaryAllAssocciations = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_TOTAL_ASSOCCIATION_INFO",
      fetchingInfo: true,
    });
    axios
      .get(`${url}/beneficiaries-insurances/${id}`, {
        headers: header,
      })
      .then((assocciations) => {
        dispatch({
          type: "GET_BENEFICIARY_ALL_ASSOCCIATIONS",
          assocciations,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_ASSOCCIATION_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_ASSOCCIATION_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_ASSOCCIATION_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};

export const getBeneficiaryAllFunds = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_TOTAL_FUND_INFO",
      fetchingInfo: true,
    });
    axios
      .get(`${url}/v1/funded-beneficiaries/${id}`, {
        headers: header,
      })
      .then((funds) => {
        dispatch({
          type: "GET_BENEFICIARY_ALL_RECEIVED_FUNDS",
          funds,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_FUND_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_FUND_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_FUND_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};
export const getBeneficiaryAllGroups = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_TOTAL_GROUP_INFO",
      fetchingInfo: true,
    });
    axios
      .get(`${url}/v1/beneficiaries-groups/beneficiary/${id}`, {
        headers: header,
      })
      .then((groups) => {
        dispatch({
          type: "GET_BENEFICIARY_ALL_GROUPS",
          groups,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_GROUP_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_GROUP_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_GROUP_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};

export const getBeneficiaryAllProperties = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_BEN_PROFILE_TOTAL_PROPERTIES_INFO",
      fetchingInfo: true,
    });
    axios
      .get(`${url}/v1/beneficiaries_properties/${id}`, {
        headers: header,
      })
      .then((properties) => {
        dispatch({
          type: "GET_BENEFICIARY_ALL_PROPERTIES",
          properties,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_PROPERTIES_INFO",
          fetchingInfo: false,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_PROPERTIES_INFO",
          fetchingInfo: false,
        });
        dispatch({
          type: "GETTING_BEN_PROFILE_TOTAL_PROPERTIES_ERRORED",
          fetchingInfoErrored: true,
        });
      });
  };
};
export const getBeneficiaryAllLetters = (id) => {
  return (dispatch) => {
    
    axios
      .get(`${url}/letters/${id}`, {
        headers: header,
      })
      .then((letters) => {
        dispatch({
          type: "GET_BENEFICIARY_ALL_LETTERS",
          letters,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
};
